import StyledSvg from './StyledSvg';

export default StyledSvg;
